import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-download-message',
    templateUrl: './download-message.component.html',
    styleUrls: ['./download-message.component.scss'],
    standalone: false
})
export class DownloadMessageComponent implements OnInit, OnDestroy {
  @Input() state: 'success' | 'error' = 'success';
  @Input() title: string = '';
  @Output() exit: EventEmitter<any> = new EventEmitter();
  message = {
    error: {
      title: '',
      subtitle: 'Por favor, inténtalo nuevamente',
      icon: 'alert-circle-outline',
    },
    success: {
      title: '',
      subtitle: 'Revísalo en tus descargas',
      icon: 'checkmark-circle-outline',
    }
  }

  ngOnInit() {
    this.message[this.state].title = this.title;
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeMessage();
    }
  }
  get iconInformation() {
    return this.state === 'success';
  }
  closeMessage() {
    this.exit.emit();
  }

}
